import { Box } from '@mui/material'
import { FC } from 'react'
import { Outlet } from 'react-router-dom'

export const WebViewLayout: FC = () => {
    return (
        <Box
            sx={{
                p: 1,
            }}>
            <Outlet />
        </Box>
    )
}
